<script>
    import {createEventDispatcher} from 'svelte/internal';
    import {clickOutside} from "../../lib/clickOutside";
    import {setFocusTo} from "../../lib/lib";
    import AppIcon from "../icons/AppIcon.svelte";

    export let id = "accuracy";
    export let value;
    export let placeholder = '';
    export let css = '';

    const prefixes = [
        {value: "±", replace: true},
        {value: "+", replace: true},
        {value: "-", replace: true},
        {value: "<", replace: true},
        {value: ">", replace: true},
        {value: "≤", replace: true},
        {value: "≥", replace: true},
        {value: "ΠΔΑ", replace: false},
        {value: "Θετικό", replace: false},
        {value: "Αρνητικό", replace: false},
    ];

    let showDropdown = false;

    const dispatch = createEventDispatcher();

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeDropdown();
        }
    }

    const onFocus = () => {
        dispatch("focus");
    }

    const onChange = (event) => {
        dispatch("change", value);
    }

    const toggleDropdown = () => {
        if (!showDropdown) {
            showDropdown = true;
            document.addEventListener('keydown', handleEscapeKey);
        } else {
            closeDropdown();
        }
    }

    const closeDropdown = () => {
        showDropdown = false;
        document.removeEventListener('keydown', handleEscapeKey);
    }

    const onSelect = (item) => {
        closeDropdown();

        if (value && item.replace) {
            let current = prefixes.find(x => x.value === value[0]);
            if (current) {
                value = value.replace(current.value, item.value);
                setFocusTo(id);
                return;
            }
        }

        value = item.value;
        setFocusTo(id);
        dispatch("change", value);
    }
</script>
<div class="dropdown-container">
    <input type="text" class="form-control { css }" id="{ id }" bind:value="{ value }" {placeholder}
           on:focus={ onFocus } on:change={ onChange }>
    <div class="toggler" on:click={ toggleDropdown }>
        <AppIcon icon="chevron-down" strokeWidth="2" size="16"/>
    </div>
    {#if showDropdown}
        <ul class="dropdown accuracy-dropdown" use:clickOutside on:click_outside="{ closeDropdown }">
            {#each prefixes as item, index}
                <li class="dropdown-item pointer" on:click={ () => onSelect(item) }>{ item.value }</li>
            {/each}
        </ul>
    {/if}
</div>

<style>
    .toggler {
        position: absolute;
        top: 5px;
        right: 1px;
        padding: 5px;
    }

    .accuracy-dropdown {

    }

    .accuracy-dropdown .dropdown-item {
        padding-top: 5px;
        padding-bottom: 5px;
    }
</style>